"use client";

import { useCapacitorPlugins } from "@/hooks/useCapacitorPlugins";

/**
 * Initializes Capacitor native plugins (splash screen, status bar, back button).
 * Renders nothing — pure side-effect component.
 */
export function CapacitorPluginsProvider() {
  useCapacitorPlugins();
  return null;
}
